"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var static_1 = require("@angular/upgrade/static");
var module_1 = __importDefault(require("./module"));
exports.default = module_1.default;
require("./auth.provider");
require("./oidc-http.interceptor");
var token_service_1 = require("./token.service");
angular_1.default.module(module_1.default)
    .factory("tokenService", static_1.downgradeInjectable(token_service_1.TokenService));
